'use strict';

const Swiper = require('swiper/bundle').Swiper;
const initPopOver = require('../js/components/initPopOver');

function displayTabProductSlider(productArray, url, $targetTabPane) {
    const dataUrl = url + '?pid=' + productArray + '&sortByPid=true';
    $.ajax({
        url: dataUrl,
        type: 'GET',
        dataType: 'html',
        success: function (data) {
            var $html = $('<div>').html(data);
            var $tiles = $html.find('.product-tiles');
            // Build Slider
            $tiles.each(function () {
                var $tile = $(this).addClass('h-100');
                var $slide = $('<div class="swiper-slide">').append($($tile));
                $targetTabPane.find('.swiper-wrapper').append($slide);
            });

            const $sliderContainer = $targetTabPane.find('.js-swiper-container');
            $sliderContainer.find('.js-swiper-slide-placeholder').remove();

            let sliderConfig;

            try {
                const rawConfig = $sliderContainer.attr('data-slider-config');
                sliderConfig = rawConfig ? JSON.parse(rawConfig) : {};
            } catch (error) {
                console.error('Failed to parse slider config JSON:', error);
                sliderConfig = {};
            }
            // Init Slider
            // eslint-disable-next-line no-new
            new Swiper($sliderContainer.find('.swiper')[0], sliderConfig);

            document.body.dispatchEvent(new CustomEvent('product:tileRendered', { detail: $sliderContainer[0], bubbles: true }));
            initPopOver();
            document.dispatchEvent(new CustomEvent('search:filtered'));
        },
        error: function (error) {
            console.error('Error loading:', dataUrl, error);
        }
    });
}

function displayTabContent($tab) {
    const tabTarget = $tab.data('bs-target');
    const tabTitle = $tab.data('product-tab-title');
    const tabProductList = $tab.data('product-tab-product-list');
    const tabActionUrl = $tab.data('action-url');

    const $targetTabPane = $(tabTarget);

    // Update Title
    $targetTabPane?.find('.js-product-tab-pane-title')?.text(tabTitle);

    // Update Button
    const $tabButtonWrapper = $tab.parent().find('.js-product-tab-button-wrapper');
    if ($tabButtonWrapper.length) {
        $tabButtonWrapper.removeClass('d-none');
        const $targetWrapper = $targetTabPane.find('.js-product-tab-pane-button-wrapper');
        $targetWrapper.empty();
        $targetWrapper.append($tabButtonWrapper);
    }

    displayTabProductSlider(tabProductList, tabActionUrl, $targetTabPane);
}

function handleTabClick() {
    $(document).on('click', '.js-product-tab', function () {
        const $tab = $(this);

        if (!$tab.hasClass('content-loaded')) {
            displayTabContent($tab);
        }

        $tab.addClass('content-loaded');
    });
}

function handleTabAutoplay($productTabs) {
    if (!$productTabs.data('tab-autoplay-enabled')) {
        return;
    }

    const delay = ($productTabs.data('tab-autoplay-delay') || 6) * 1000;
    const DESKTOP_BREAKPOINT = 1200;
    let timer = null;
    let prefetchTimeout = null;

    function nextTab() {
        if (window.innerWidth < DESKTOP_BREAKPOINT) {
            return;
        }

        const $tabs = $productTabs.find('.js-product-tab');
        const currentIndex = $tabs.index($tabs.filter('.active'));
        const $next = $tabs.eq((currentIndex + 1) % $tabs.length);

        const tabSwiperEl = $productTabs.find('.js-global-swiper-slider .swiper')[0];
        if (tabSwiperEl && tabSwiperEl.swiper) {
            tabSwiperEl.swiper.slideTo($next.closest('.swiper-slide').index());
        }

        if (!$next.hasClass('content-loaded') && delay > 1000) {
            // Pre-fetch content 1s before the switch
            displayTabContent($next);
            $next.addClass('content-loaded');
            prefetchTimeout = setTimeout(() => $next.trigger('click'), 1000);
        } else {
            $next.trigger('click');
        }
    }

    function stop() {
        clearInterval(timer);
        clearTimeout(prefetchTimeout);
        timer = null;
        prefetchTimeout = null;
    }

    function start() {
        stop();
        timer = setInterval(nextTab, delay);
    }

    start();

    $productTabs
        .on('mouseenter.tabAutoplay', stop)
        .on('mouseleave.tabAutoplay', start)
        .on('click.tabAutoplay', '.js-product-tab', start);
}

// Create Observer to request Products when in View
const observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const $tabs = $(entry.target);

            // Handle First Tab
            const $firstTab = $tabs.find('.js-product-tab').first();
            if ($firstTab.length) {
                displayTabContent($firstTab);
                $firstTab.addClass('active content-loaded').attr('aria-selected', 'true');
            }

            // Wire up autoplay hooks if enabled for this component
            handleTabAutoplay($tabs);

            // Stop Observing
            obs.unobserve(entry.target);
        }
    });
}, { threshold: [0] });

// Observe each .product-tabs
$('.product-tabs').each(function () {
    observer.observe(this);
});

$(document).ready(function () {
    handleTabClick();
});
